module.exports = __webpack_public_path__ + "static/sam-34d744767cf8bea762c48fc226aa0d3f.png";